import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=37db9910&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=37db9910&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db9910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37db9910')) {
      api.createRecord('37db9910', component.options)
    } else {
      api.reload('37db9910', component.options)
    }
    module.hot.accept("./GroupDetail.vue?vue&type=template&id=37db9910&scoped=true", function () {
      api.rerender('37db9910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/GroupDetail.vue"
export default component.exports